export const PAGE_SIZE = 10

export const HELP_TEXT_GENERAL =
  'Назовите статью так, чтобы из названия было сразу понятно, какие пункты и заявки в неё подавать.'

export const HELP_TEXT_PERMISSIONS =
  'Добавьте пользователей, которые могут создавать заявки в эту статью. Если вы даете доступ руководителю, он также сможет поделиться статьей со своей командой.'
